// extracted by mini-css-extract-plugin
module.exports = {"Link":"FooterLink_Link__27zNc","ActiveLink":"FooterLink_ActiveLink__-ZEs9 FooterLink_Link__27zNc"};